import { AccountTree, Analytics, Apartment, Engineering, Group, Home, Interests, LineAxis, Place, Report } from "@mui/icons-material"

const pimpinanRoutes = [
    {
        type: "route",
        name: "Dashboard",
        key: ['/adminp'],
        route: "/adminp",
        icon: <Home size="12px" color="warning" />,
        noCollapse: true,
    },
    {
        type: "route",
        name: "Perencanaan",
        key: ['/adminp/perencanaan', '/adminp/perencanaan/detail', '/adminp/perencanaan/rincian-belanja'],
        route: "/adminp/perencanaan",
        icon: <Analytics size="12px" color="info" />,
        noCollapse: true,
    },
    {
        type: "route",
        name: "Struktur Anggaran",
        key: ['/adminp/struktur-anggaran'],
        route: "/adminp/struktur-anggaran",
        icon: <AccountTree size="12px" color="success" />,
        noCollapse: true,
    },
    {
        type: "route",
        name: "Laporan",
        key: ['/adminp/laporan', '/adminp/laporan/detail', '/adminp/laporan/rincian-belanja', '/adminp/laporan/komponen'],
        route: "/adminp/laporan",
        icon: <Report size="12px" color="secondary" />,
        noCollapse: true,
    },
    {
        type: "route",
        name: "PDN & TKDN",
        key: ['/adminp/pdn'],
        route: "/adminp/pdn",
        icon: <LineAxis size="12px" color="primary" />,
        noCollapse: true,
    },
    {
        type: "collapse",
        name: "Paket Pekerjaan",
        key: ['belanja', 'belanja-modal', 'projek-strategis', 'paket-dak'],
        icon: <Engineering size="12px" color="error" />,
        collapse: [
            {
                name: "Komponen Belanja",
                key: ['/adminp/belanja', '/adminp/belanja/komponen'],
                route: "/adminp/belanja",
            },
            {
                name: "Belanja Modal",
                key: ['/adminp/belanja-modal', '/adminp/belanja-modal/komponen'],
                route: "/adminp/belanja-modal",
            },
            {
                name: "Projek Strategis",
                key: ['/adminp/projek-strategis', '/adminp/projek-strategis/komponen'],
                route: "/adminp/projek-strategis",
            },
            {
                name: "DAK",
                key: ['/adminp/paket-dak', '/adminp/paket-dak/komponen'],
                route: "/adminp/paket-dak",
            },
        ],
    },
    {
        type: "route",
        name: "Lokasi Pekerjaan",
        key: ['/adminp/lokasi-pekerjaan'],
        route: "/adminp/lokasi-pekerjaan",
        icon: <Place size="12px" color="success" />,
        noCollapse: true,
    },
]

export default pimpinanRoutes